import tw, { styled } from 'twin.macro';

import Graphic from './Graphic';

const SmallGraphic = styled(Graphic)`
  ${tw`h-auto w-full max-w-xs`}
`;

export default SmallGraphic;
